
import { Area, Contract } from "../../classes"

const AreaModule = {
  namespaced: true,
  state: {
    areas: [],
    vacancyAreas: [],
    bookingAreas: [],
    dailyActiveAreas: [],
    overallArea: [],
    overallAreaMarketId: '',
    overallAreaProjectId: '',
    currentArea: null,
    projectAreaCount: 0,
    areaBookingSummaryByMarket: null,
    areaBookingSummaryByProject: null,
    invoiceDueDateSummary: null,
  },
  actions: {
    createArea: async ({ commit, dispatch }, payload) => {
      try {
        if (payload.name !== "" && payload.size !== "") {
          const data = await Area.createArea({
            name: payload.name,
            size: payload.size,
            marketId: payload.marketId,
          });
          commit("updateAreasByAreas", [data]);
          if (data?.project?.objectId)
            dispatch("projectAreaCount", { projectId: data.project.objectId })
          return data;
        } else {
          return false;
        }
      } catch (error) {
        throw error
      }
    },
    getVacancyAreas: async ({ commit, rootGetters }, payload) => {
      try {
        const data = await Area.getVacancyAreas({
          marketId: rootGetters["markets/getMarketId"],
        });
        commit("setVacancyAreas", data);
        return data
      } catch (err) {
        throw err
      }
    },
    getAreasByIds: async ({ commit }, { ids }) => {
      try {
        const data = await Area.getAreasByIds(ids);
        commit("updateAreasByAreas", data);
        return data
      } catch (err) {
        throw err
      }
    },
    updateAreaProducts: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Area.updateAreaProducts(payload);
        // commit("example", {example: data.result});
        // dispatch("example", {example: data.result});
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateArea: async ({ commit }, formData) => {
      try {
        const data = await Area.updateArea(formData);
        commit("updateAreasByAreas", [data]);
        return data
      } catch (err) {
        throw err
      }
    },
    updateOrderArea: async ({ commit }, formData) => {
      try {
        const data = await Area.updateOrderArea(formData);
        commit("updateAreasByAreas", data);
        return data
      } catch (err) {
        throw err
      }
    },
    removeArea: async ({ commit, dispatch }, id) => {
      try {
        const data = await Area.removeArea(id);
        commit("removeArea", data);
        if (data?.project?.objectId)
          dispatch("projectAreaCount", { projectId: data.project.objectId })
        return data
      } catch (err) {
        throw err
      }
    },
    getAvailableAreas: async ({ commit }, fromData) => {
      try {
        const data = await Area.getAvailableAreas(fromData);
        commit("setVacancyAreas", data);
        return data
      } catch (err) {
        throw err
      }
    },
    getAvailableArea: async ({ commit }, fromData) => {
      try {
        const data = await Area.getAvailableArea(fromData);
        // commit("setVacancyAreas", data);
        return data
      } catch (err) {
        throw err
      }
    },
    getBookingAreas: async ({ commit }, marketId) => {
      try {
        const data = await Area.getBookingAreas(marketId);
        commit("setBookingAreas", data);
        return data
      } catch (err) {
        throw err
      }
    },
    getDialyActiveAreas: async ({ commit }, marketId) => {
      try {
        const data = await Area.getDialyActiveAreas(marketId);
        commit("setDailyActiveAreas", data);
        return data
      } catch (err) {
        throw err
      }
    },
    sortAreas: ({ commit, state }) => {
      try {
        let items = state.areas
        commit("setAreas", items);
        items.sort(function (a, b) {
          if (b.order > a.order) return -1
          else return 1
        })
        commit("setAreas", items);
        return items
      } catch (err) {
        throw err
      }
    },
    projectAreaCount: async ({ commit }, projectId) => {
      try {
        commit("setProjectAreaCount", 0);
        const data = await Area.projectAreaCount(projectId);
        commit("setProjectAreaCount", data);
        return data
      } catch (err) {
        throw err
      }
    },
    //Overall Area
    getOverallAreas: async ({ commit, state }, payload) => {
      try {
        let data
        if (
          state.overallArea
          && state.overallArea.length
          && state.overallAreaMarketId == payload.marketId
          && state.overallAreaProjectId == payload.projectId
        ) {
          data = state.overallArea
        } else {
          data = await Area.getOverallAreas(payload);
          commit("setOverallArea", data);
          commit("setOverallAreaMarketId", payload.marketId);
          commit("setOverallAreaProjectId", payload.projectId);
        }
        return data
      } catch (err) {
        throw err
      }
    },
    getProjectArea: async ({ commit }, fromData) => {
      try {
        const data = await Area.getProjectArea(fromData);
        commit("setAreas", data);
        return data
      } catch (err) {
        throw err
      }
    },
    getAreaBookingSummaryByMarket: async ({commit} , {marketId}) => {
      try {
        const data = await Area.getAreaBookingSummaryByMarket(marketId);
        commit("setAreaBookingSummaryByMarket", data)
        return data
      } catch (err) {
        throw err
      }
    },
    getAreaBookingSummaryByProject: async ({commit} , {projectId}) => {
      try {
        const data = await Area.getAreaBookingSummaryByProject(projectId);
        commit("setAreaBookingSummaryByProject", data)
        return data
      } catch (err) {
        throw err
      }
    },
    getInvoiceDueDateSummaryByMarket: async ({commit} , {marketId}) => {
      try {
        const data = await Area.getInvoiceDueDateSummaryByMarket(marketId);
        commit("setInvoiceDueDateSummary", data)
        return data
      } catch (error) {
        throw error
      }
    },
    getInvoiceDueDateSummaryByProject: async ({commit} , {projectId}) => {
      try {
        const data = await Area.getInvoiceDueDateSummaryByProject(projectId);
        commit("setInvoiceDueDateSummary", data)
        return data
      } catch (error) {
        throw error
      }
    }
  },
  getters: {
    projectAreaCount: (state) => state.projectAreaCount,
    getOverallAreas: (state) => state.overallArea,
    getVacancyAreas: (state) => state.vacancyAreas,
    getHashArea: (state) => {
      let hash = {}
      for (let area of state.areas) {
        hash[area.objectId] = area
      }
      return hash
    },
    getBookingAreas: (state) => state.bookingAreas,
    getAreas: (state) => state.areas?.map(i => {
      i.currentProducts = i.areaBooking ? i.areaBooking.products : i.products && i.products.length ? i.products : [{ name: "-" }]
      return i
    }),
    getCurrentArea: (state) => state.currentArea,
    getContracts: (state) => {
      let contracts = []
      for (let area of state.areas) {
        if (area.contract && !contracts.find(d => d.objectId == area.contract.objectId)) {
          let contract = new Contract(area.contract)
          contract.areas = state.areas.filter(d => d.contract && d.contract.objectId == contract.objectId)
          contracts.push(contract)
        }
      }
      return contracts
    },
    getAreaBookingSummaryByMarket: (state) => state.areaBookingSummaryByMarket,
    getAreaBookingSummaryByProject: (state) => state.areaBookingSummaryByProject,
    getInvoiceDueDateSummary: (state) => state.invoiceDueDateSummary,
  },
  mutations: {
    setProjectAreaCount: (state, number) => {
      state.projectAreaCount = number;
    },
    setVacancyAreas: (state, areas) => {
      state.vacancyAreas = areas;
    },
    updateAreasByAreas: (state, areas) => {
      for (let area of areas) {
        let index = state.areas.findIndex(i => i.objectId === area.objectId);
        if (index > -1) {
          state.areas[index] = area;
        } else {
          state.areas.push(area)
        }
      }
      const temp = state.areas
      state.areas = []
      state.areas = temp
    },
    setAreas: (state, areas) => {
      state.areas = areas || []
    },
    removeArea(state, area) {
      if (state.areas) {
        let index = state.areas.findIndex(i => i.objectId === area.objectId);
        state.areas.splice(index, 1);
      }
    },
    setBookingAreas(state, areas) {
      state.bookingAreas = areas || []
    },
    setDailyActiveAreas(state, areas) {
      state.dailyActiveAreas = areas || []
    },

    setOverallArea: (state, overallArea) => {
      state.overallArea = overallArea || []
    },
    setOverallAreaMarketId: (state, marketId) => {
      state.overallAreaMarketId = marketId || ''
    },
    setOverallAreaProjectId: (state, projectId) => {
      state.overallAreaProjectId = projectId || ''
    },

    setCurrentArea: (state, currentArea = null) => {
      state.currentArea = currentArea
    },
    setAreaBookingSummaryByMarket: (state, data) => {
      state.areaBookingSummaryByMarket = data;
    },
    setAreaBookingSummaryByProject: (state, data) => {
      state.areaBookingSummaryByProject = data;
    },
    setInvoiceDueDateSummary: (state, data) => {
      state.invoiceDueDateSummary = data;
    }
  },
};
export default AreaModule;
